exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoom-on-hover{position:relative;overflow:hidden}.zoom-on-hover .def{width:100%}.zoom-on-hover .zoom{position:absolute;opacity:0;-webkit-transform-origin:top left;transform-origin:top left;z-index:1;width:1000px;height:auto;max-width:none;cursor:-webkit-zoom-in;cursor:zoom-in}.zoom-on-hover.zoomed .zoom{opacity:1}.zoom-on-hover.zoomed .def{opacity:0}@media screen and (max-width:768px){.zoom-on-hover .zoom{display:none}.zoom-on-hover.zoomed .zoom{opacity:0}.zoom-on-hover.zoomed .def{opacity:1}}", ""]);

// exports
